<template>
    <div class="card policy-info-card shadow-sm mb-3">
        <!-- Modern Header Action Bar -->
        <div class="card-header policy-info-card-header py-3 px-3 px-md-4 d-flex align-items-center justify-content-between flex-wrap gap-2"
             v-if="!editing && !insert">
            <div class="d-flex align-items-center gap-2">
                <span class="policy-icon-box">
                    <i class="bi bi-shield-check"></i>
                </span>
                <div>
                    <div class="d-flex align-items-center gap-2">
                        <h6 class="mb-0 fw-bold policy-main-num">{{ data.quotaId }}</h6>
                        <span class="status-badge-pill badge--approved">
                            <i class="bi bi-check-circle-fill me-1"></i> Aktiv
                        </span>
                    </div>
                    <small class="text-muted" style="font-size: 0.78rem;">Sığorta şəhadətnaməsi və müqavilə şərtləri</small>
                </div>
            </div>
            <div class="d-flex align-items-center flex-wrap gap-2">
                <button type="button" class="btn action-btn action-btn--muted" @click="GetData()">
                    <i class="bi bi-arrow-clockwise me-1"></i>
                    <span>Yeniləmək</span>
                </button>
                <button type="button" class="btn action-btn action-btn--info" @click="printVis = true">
                    <i class="bi bi-printer me-1"></i>
                    <span>Çap</span>
                </button>
            </div>
        </div>

        <!-- Card Body -->
        <div class="card-body p-3 p-md-4" v-loading="loading">
            <Data :data="data" v-if="!editing && !insert"></Data>
        </div>
    </div>

    <!-- Print Dialog -->
    <el-dialog v-model="printVis" title="Sığorta şəhadətnaməsi - Çap" width="600px"
        modal-class="modal-class" :close-on-click-modal="false" :destroy-on-close="true">
        <div class="text-center py-4">
            <i class="bi bi-printer text-primary" style="font-size: 3rem;"></i>
            <h6 class="mt-3 fw-bold">{{ data.quotaId }}</h6>
            <p class="text-muted" style="font-size: 0.85rem;">Sənəd çap olunmağa hazırdır</p>
        </div>
        <template #footer>
            <div class="d-flex justify-content-end gap-2 pt-2 border-top">
                <button type="button" class="btn action-btn action-btn--muted" @click="printVis = false">
                    Bağla
                </button>
                <button type="button" class="btn action-btn action-btn--info" @click="printVis = false">
                    <i class="bi bi-printer me-1"></i>
                    <span>Çap et</span>
                </button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import Data from "./Components/Data.vue";

export default {
    name: "PolicyInfoMain",
    props: {
        priv: Object
    },
    components: {
        Data
    },
    data() {
        return {
            data: {
                quotaId: "SS-2025-000123",
                quotaDateStr: "16.08.2025",
                quotaFullNumber: "Q-2025-007",
                generalDate: "01.08.2025",
                generalFullNumber: "GM-45678/2025",
                period: 36,
                currency: "AZN",
                payType: "Aylıq",
                insurerSignDate: "19.08.2025 16:20:00",
                curatorSignDate: null,
                clientSignDate: "18.08.2025 13:55:00",
                agentName: "Vəfa Əbilova",
                underwritingName: "Elvin Rzayev",
                curatorName: "Samir Qasımov",

                insured: {
                    name: "Xəzər Holdinq MMC",
                    address: "Bakı, Nərimanov r., Heydər Əliyev pr. 125",
                    phone: "+994 12 555 66 77",
                    clientSector: "Neft sektoru",
                    voen: "878455554865"
                },

                beneficiary: {
                    name: "Leyla Quliyeva",
                    address: "Bakı, Yasamal r., Şərifzadə küç. 45"
                }
            },
            loading: false,
            editing: false,
            insert: false,
            printVis: false,
            dialogVis: false
        };
    },
    methods: {
        GetData() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        ToggleEdit() {
            this.$emit('toggle-nav');
        }
    },
    mounted() {
        if (this.$route.path.split("/")[3] === "new") {
            this.insert = true;
            this.$emit('toggle-nav');
        }
        this.GetData();
    }
};
</script>

<style scoped lang="scss">
.policy-info-card {
    border: 1px solid var(--app-border, #e2e8f0);
    border-radius: var(--app-radius, 8px);
    background: var(--app-surface, #ffffff);
}

.policy-icon-box {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: rgba(11, 79, 156, 0.1);
    color: var(--bs-info, #0b4f9c);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
}

.policy-main-num {
    font-size: 1rem;
    color: var(--app-heading, #1e293b);
}

.status-badge-pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 10px;
    border-radius: 9999px;
    font-size: 0.74rem;
    font-weight: 700;

    &.badge--approved {
        background: rgba(16, 185, 129, 0.12);
        color: #059669;
        border: 1px solid rgba(16, 185, 129, 0.35);
    }
}

[data-theme="dark"] {
    .policy-info-card {
        background: #182029;
        border-color: #2e3846;
    }

    .policy-icon-box {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    .policy-main-num {
        color: #f1f5f9;
    }

    .status-badge-pill.badge--approved {
        background: rgba(16, 185, 129, 0.18);
        color: #34d399;
        border-color: rgba(52, 211, 153, 0.35);
    }
}
</style>